import { CircularProgress, Container, TextField } from '@mui/material';
import React, { useState } from 'react';
import { FaInfoCircle } from 'react-icons/fa';
import { useHistory } from 'react-router-dom';
import Swal from 'sweetalert2';
import Footer from '../../Components/Footer';
import Header from '../../Components/Header';
import IUser from '../../Interfaces/user/user.interface';
import api, { login } from '../../Services/ApiService';
import { Title } from '../Home/styles';
import { Form, FormItem, StyledButton } from './styles';

// import { Container } from './styles';

const Login: React.FC = () => {
  const [email,setEmail] = useState<string>('');
  const [senha,setSenha] = useState<string>('');
  const [loading,setLoading] = useState<boolean>(false);
  const history = useHistory();

  const handleSubmit = async (event:React.FormEvent) => {
    event.preventDefault();
    setLoading(true);
    const user: IUser = {
      email,
      senha
    }
    try {
      const { data } = await api.post<string>('/login/authenticate',user);
      login(data);
      history.push('/AreaDoMonitor');
    } catch (error:any) {
      console.log(error);
      setLoading(false);
      return Swal.fire({
        title:'Erro!',
        text:`Por favor, confira seus dados e tente novamente`,
        icon: 'error'
      })
    }
  }
  
  return (
    <>
      <Header active='Login'/>
      <Container style={{backgroundColor:'rgba(255,255,255,0.8)'}} maxWidth="sm">
        <Title>Login</Title>
        <Form onSubmit={handleSubmit}>
          <FormItem>
            <TextField 
              type="email" 
              required 
              label="Seu email" 
              value={email || ''}
              onChange={(event)=>setEmail(event.target.value)}
              placeholder="Insira seu email"
              style={{width:'100%'}}
              />
          </FormItem>
          <FormItem>
            <TextField 
              type="password" 
              required 
              label="Sua senha" 
              value={senha || ''}
              onChange={(event)=>setSenha(event.target.value)}
              placeholder="Insira sua senha"
              style={{width:'100%'}}
              />
          </FormItem> 
          <StyledButton 
            variant="contained"
            type="submit">
              {loading ? <CircularProgress/> : 'Entrar'}
          </StyledButton>
          <small><FaInfoCircle/>Esta área é destinada aos monitores do Planetário</small>
        </Form>
      </Container>
      <Footer/>
    </>
  );
}

export default Login;